/**
 * Patient brief ("clinical memory", owner meeting 2026-10-27): the
 * "Today's briefs" page per provider (`/briefs`), the chart side panel and
 * the schedule hover rows (used by the chart and schedule modules).
 */
import { defineManifest } from '@velora/contracts';
import { BRIEF_ENTITY, BRIEF_PERMISSIONS as P } from '@velora/contracts/patient-brief';
import { defineWebModule } from '../../app/module.js';

export default defineWebModule({
  manifest: defineManifest({
    id: 'patient-brief',
    title: 'Patient brief',
    version: '0.1.0',
    owner: 'WP5-PATIENT-BRIEF',
    entitlementKey: null,
    permissions: [P.view],
    routes: [
      {
        id: 'briefs',
        path: '/briefs',
        title: "Today's briefs",
        officeScope: 'location',
        permission: P.view,
        readsPhi: true,
      },
    ],
    nav: [
      {
        label: "Today's briefs",
        group: 'clinical',
        routeId: 'briefs',
        icon: 'book-open-text',
        order: 12,
        permission: P.view,
      },
    ],
    commands: [
      {
        id: 'patient-brief.day',
        title: "Today's patient briefs",
        keywords: [
          'brief',
          'briefs',
          'memory',
          'huddle',
          'talking points',
          'pre-visit',
          'my patients',
        ],
        routeId: 'briefs',
        permission: P.view,
      },
    ],
    sseEntityKeys: [BRIEF_ENTITY],
    phiReadPoints: ['patient-brief.view', 'patient-brief.summaries', 'patient-brief.day'],
  }),
  pages: {
    briefs: () => import('./BriefsPage.js'),
  },
});
